import type { PageSchemaField } from '@shopexperts/shared';

const ENTITY_FIELD_TYPES = new Set(['partner_badge', 'service_category', 'service_subcategory']);

export function normalizeEntityId(value: unknown): number | null {
  if (typeof value === 'number' && Number.isInteger(value) && value > 0) return value;
  if (typeof value === 'string' && value.trim()) {
    const trimmed = value.trim();
    if (!/^\d+$/.test(trimmed)) return null;
    const parsed = Number(trimmed);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }
  if (value && typeof value === 'object' && 'id' in value) {
    return normalizeEntityId((value as { id?: unknown }).id);
  }
  return null;
}

export function isEntityMetafield(field: Pick<PageSchemaField, 'type'>): boolean {
  return ENTITY_FIELD_TYPES.has(field.type);
}

export function normalizeMetafieldDraftValue(field: Pick<PageSchemaField, 'type'>, value: unknown): unknown {
  return isEntityMetafield(field) ? normalizeEntityId(value) : value;
}

export function entitySelectValue(value: unknown): string {
  return normalizeEntityId(value)?.toString() || '';
}
